module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-08-3a1a094cff7c96e683e2e30a827325f3.png";